import React from "react";
import Chevron from "./Chevron";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  dark = false,
}) {
  const alignClass = align === "left" ? "text-left" : "text-center mx-auto";
  const container = align === "left" ? "" : "max-w-3xl";
  const titleColor = dark ? "text-white" : "text-delfi-navy";
  const descColor = dark ? "text-white/75" : "text-delfi-navy/70";
  return (
    <div className={`${container} ${alignClass}`}>
      {eyebrow && (
        <div
          className={`inline-flex items-center gap-2 text-delfi-red text-xs tracking-[0.2em] uppercase font-semibold ${
            align === "center" ? "justify-center" : ""
          }`}
        >
          <Chevron size={14} /> {eyebrow}
        </div>
      )}
      <h2 className={`headline-section text-3xl md:text-5xl mt-4 ${titleColor}`}>{title}</h2>
      {description && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${descColor}`}>
          {description}
        </p>
      )}
    </div>
  );
}
